import {
  type BlokItem,
  DynamicRender,
  getAssetFromStoryblok,
  sbEditable,
  type SBProps,
  type StoryblokAsset,
} from '../../../../utils';
import { FloatingAvatars } from './FloatingAvatars';

interface SBOpeningsBannerSectionProps {
  title?: string;
  subtitle?: string;
  cta: BlokItem[];
  avatars: StoryblokAsset[];
}

export const SBOpeningsBannerSection = ({ blok }: SBProps<SBOpeningsBannerSectionProps>) => {
  const { title, subtitle, cta, avatars } = blok;

  const avatarImages = avatars?.map(image => ({
    ...getAssetFromStoryblok(image, { type: 'image' }),
    id: image.id,
  }));

  return (
    <section
      {...sbEditable(blok)}
      className="bg-primary-700 relative mx-auto max-w-7xl px-4 py-[184px] lg:px-0"
    >
      <FloatingAvatars avatars={avatarImages} />
      <header className="relative grid justify-items-center gap-12 md:gap-10">
        <div className="max-w-[960px] text-center">
          <p className="font-permanent-marker mb-6 text-2xl font-semibold text-white md:text-[32px]">
            {subtitle}
          </p>
          <h2 className="text-[46px] font-bold text-white md:text-7xl">{title}</h2>
        </div>
        <DynamicRender data={cta} />
      </header>
    </section>
  );
};
